import { IEplassProjectData, ProjectViewType } from '../../../../redux/user/sliceUserProjects';

/**
 * Creates the category structure for the tile view.
 * @param data - Project data to organise.
 */
export const buildProjectGroups = (data: IEplassProjectData[]) => {
    const tree: { [id: string]: IEplassProjectData[] } = {};

    data.forEach((x: IEplassProjectData): void => {
        if (!tree[x.category]) {
            tree[x.category] = [];
        }

        tree[x.category].push(x);
    });

    return tree;
};

/**
 * Filters a list of user projects depending on the active view type and/or filter text.
 * @param projects - List of user projects.
 * @param favourites - List of user projet favourites.
 * @param filter - String value to filter the projects by.
 * @param viewType - Active view type.
 * @returns Filtered projects.
 */
export const filterProjects = (
    projects: IEplassProjectData[],
    favourites: string[],
    filter: string,
    viewType: ProjectViewType,
): IEplassProjectData[] => {
    return projects.filter(project =>
        filter && !new RegExp(filter, 'i').test(project.title)
            ? /** Remove any projects that do not match filter (if defined). */
              false
            : /** If viewType is 'Favourites' then further filter using favourites. */
              viewType !== ProjectViewType.Favourites || favourites.indexOf(project.replicaId) >= 0,
    );
};
